/**
 * @fileoverview PATCH handler for the "/integrations/direct/cdi/sources/:source_id" endpoint
 */
import fetch from "@lib/fetch";

import type { CDISource } from "../integrationsDirectCdiSources/types";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { patchIntegrationsDirectCdiSourcesSourceIdCacheKeys } from "./constants";
import type { UpdateCDISource } from "./types";

export const patchIntegrationsDirectCdiSourcesSourceId = reactQueryMutationAdapter(
  patchIntegrationsDirectCdiSourcesSourceIdCacheKeys,
  (props: UpdateCDISource): Promise<CDISource> => {
    return fetch(`/integrations/direct/cdi/sources/${props.id}`, "PATCH", props, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
